module.exports = __webpack_public_path__ + "static/assets/f13681e460c5e2fef86d700c0292faac.gif";